namespace RioERP.Enquiry {
    export namespace EnquiryService {
        export const baseUrl = 'Enquiry/Enquiry';

        export declare function Create(request: Serenity.SaveRequest<EnquiryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<EnquiryRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<EnquiryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<EnquiryRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetDetail(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AssignAgent(request: AssignAgentRequest, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Enquiry/Enquiry/Create",
            Update = "Enquiry/Enquiry/Update",
            Delete = "Enquiry/Enquiry/Delete",
            Retrieve = "Enquiry/Enquiry/Retrieve",
            List = "Enquiry/Enquiry/List",
            GetDetail = "Enquiry/Enquiry/GetDetail",
            AssignAgent = "Enquiry/Enquiry/AssignAgent"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetDetail', 
            'AssignAgent'
        ].forEach(x => {
            (<any>EnquiryService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
